
import * as THREE from "three";
import {WebGLRenderTarget} from "three";

function disposeMesh(node:THREE.Mesh) {
    if (node.geometry) {
        node.geometry.dispose();
        node.geometry = new THREE.Geometry(); // fixed problem
    }

    const material = node.material as THREE.Material
    if (material) {
        material.dispose()
    }

    const materialArray = node.material as THREE.Material[]
    if (materialArray && materialArray.length) {
        for (let mat of materialArray) {
            mat.dispose()
        }
    }
}

function disposeMeshHierchy(mesh:THREE.Mesh, callback?:((node:THREE.Mesh)=>void)) {
    for (let child of mesh.children) {
        const childMesh = child as THREE.Mesh
        if (!childMesh || childMesh === mesh) continue
        disposeMeshHierchy(childMesh, callback);
    }
    disposeMesh(mesh)
}

export function disposeScene(scn:THREE.Scene) {

    scn.traverse ((object) => {
        if (object instanceof THREE.Mesh) {
            const mesh = object as THREE.Mesh
            if (mesh) {
                disposeMeshHierchy(mesh)
            }
        } else if (object instanceof THREE.Scene) {
            const _scn = object as THREE.Scene
            if (_scn && _scn !== scn) {
                disposeScene(_scn)
            }
        }
    });
}

export function disposeRenderer(renderer:THREE.WebGLRenderer) {
    const target = renderer.getRenderTarget() as WebGLRenderTarget
    if (target) {
        target.dispose()
    }
    renderer.dispose()
}

const timeouts:any[] = []
export function safelyTimeout(handler: ()=>void, timeout?: number): number {
    const handle = window.setTimeout(()=>{
        const index = timeouts.indexOf(handle)
        if (index) {
            timeouts.splice(index, 1);
        }
        handler()
    }, timeout)
    timeouts.push(handle)
    return handle
}

export function safelyInterval(handler: ()=>void, timeout?: number): number {
    const handle = window.setInterval(()=>{
        handler()
    }, timeout)
    timeouts.push(handle)
    return handle
}

export function clearTimeouts() {
    while(timeouts.length > 0) {
        const handle = timeouts.pop()
        clearInterval(handle)
    }
}